import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ChangeProgComponent } from '../change-prog/change-prog.component';
import { ReturnAllDateComponent } from '../return-all-date/return-all-date.component';

@Component({
  selector: 'app-tour-invoice-list',
  templateUrl: './tour-invoice-list.component.html',
  styleUrls: ['./tour-invoice-list.component.css']
})
export class TourInvoiceListComponent implements OnInit {

  public menu_item_id = '97';
  public add_auth;
  public edit_auth;
  public del_auth;

  public pay_menu_item_id = '98';
  public pay_auth;

  branchList = [];
  private dp = [];
  displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 'final_total',
    'branch_name', 'reg_status', 'inv_status', 'created_by', 'register', 'edit', 'print_invoice', 'print', 
    'change', 'pay', 'return'];  // 

  displayedColumns2 = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 'final_total',
    'branch_name', 'reg_status', 'inv_status', 'created_by'];

  model = {
    'invoice_no': '', 'customer_name': '', 'mobile': '', 'trip_name': '', 'trip_number': '',
    'title': 'قائمة الفواتير', 'reg_from_date': new Date(), 'reg_to_date': new Date(),
    'dep_from_date': new Date(), 'dep_to_date': new Date(), 'trip_id': '0', 'type_id': 'all', 
    'branch_id' : '0', 'depart_flight_id': '0', 'return_flight_id': '0', 'user_name': 'all'
  };

  search_prog = {
    'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`trip`', 'selected_no': 'trip_id',
      'field_list': ['trip_name', 'trip_number']
    }]
  };

  search_flight = {
    'placeholder': 'اسم رحلة الطيران/ رقم رحلة الطيران', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`flight`', 'selected_no': 'flight_id',
      'field_list': ['flight_name', 'flight_number', 'flight_date']
    }]
  };

  type_list = [
    { 'type_id': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
    { 'type_id': 'program', 'type_name': 'عقود البرامج السياحية', 'type_name_en': 'Tourism Programs Contracts' },
    { 'type_id': 'special_prog', 'type_name': 'عقود البرامج الخاصة', 'type_name_en': 'Special Programs Contracts' },
    { 'type_id': 'flight', 'type_name': 'عقود رحلات الطيران', 'type_name_en': 'Flight Contracts' },
    { 'type_id': 'flight_block', 'type_name': 'عقود بلوكات الطيران', 'type_name_en': 'Flight Blocks Contracts' }
  ];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  changeDialogRef: MatDialogRef<ChangeProgComponent>;
  returnDateDialogRef: MatDialogRef<ReturnAllDateComponent>;

  id; no;
  users = [];
  toDelete = [];

  limit_amount = 0;
  agent_balance = 0;
  remain_balance = 0;

  Invoice_List; Program_Placeholder; Search_Msg;
  Success_Msg; Error_Msg; Ret_No_Msg;
  Cancel_Invoice_Msg; Ret_All_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router, 
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Invoice_List').subscribe((res: string) => {
      this.Invoice_List = res;
    });
    this.model['title'] = this.Invoice_List;

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    this.search_prog.placeholder = this.Program_Placeholder;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
    
    translate.get('Ret_All_Msg').subscribe((res: string) => {
      this.Ret_All_Msg = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Cancel_Invoice_Msg').subscribe((res: string) => {
      this.Cancel_Invoice_Msg = res;
    });
  }

  ngOnInit() {

    this.model['dep_from_date'] = undefined;
    this.model['dep_to_date'] = undefined;
    let obj;

    if (this.applicationConstants.user_info['user_id'] != undefined) {
      let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
        " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
        " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.branchList = data.data['list'];
          this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
        });

      this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
      this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
      this.pay_auth = this.utils.getAuth(this.pay_menu_item_id, this.applicationConstants.ADD_AUTH);

      let condition = '';
      if (this.applicationConstants.user_info['user_name'] != 'mas')
        condition += " AND `user`.`user_name` != 'mas'";

      query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
        " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          
          this.users = data.data['list'];
          this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
        });
    }
    else {
      obj = { cmd: 'getAcctBalance', acct_number: this.applicationConstants.user_info['acct_number'], acct_type: 'acct', for_agent: '1' };

      this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.limit_amount = this.applicationConstants.user_info['limit_amount'];
          this.agent_balance = Number(data.status['msg']) * -1;
          this.remain_balance = Number(this.applicationConstants.user_info['limit_amount']) - Number(data.status['msg']);
        });

      this.search_prog['table_list'][0]['condition'] = " AND (`trip`.`agent_only` = '1' OR `trip`.`agent_only` = '2')";
        
      this.type_list = [
        { 'type_id': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
        { 'type_id': 'program', 'type_name': 'عقود البرامج السياحية', 'type_name_en': 'Tourism Programs Contracts' },
        { 'type_id': 'flight', 'type_name': 'عقود رحلات الطيران', 'type_name_en': 'Flight Contracts' },
        { 'type_id': 'flight_block', 'type_name': 'عقود بلوكات الطيران', 'type_name_en': 'Flight Blocks Contracts' }
      ];

      this.edit_auth = true;
      // this.model['type_id'] = 'flight_block';
      this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
        'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'register', 'print_invoice', 'print'];  // , 'reg_status', 'pay', 'return'
    }
  }

  getContractType() {

    if (this.applicationConstants.user_info['user_id'] != undefined) {
      if (this.model['type_id'] == 'flight_block')
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'register', 
          'print_invoice', 'print', 'pay', 'return'];
  
      else if (this.model['type_id'] == 'program')
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'edit', 'print_invoice', 
          'print', 'change', 'pay', 'return'];
  
      else if (this.model['type_id'] == 'special_prog')
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'edit', 'print_invoice', 
          'print', 'pay', 'return'];
          
      else 
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'print_invoice', 
          'print', 'pay', 'return'];  // 'edit', 
    }
    else {
      if (this.model['type_id'] == 'flight_block')
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'register', 
          'print_invoice', 'print'];
  
      else if (this.model['type_id'] == 'flight')
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by'];  // , 'print_invoice', 'print'

      else 
        this.displayedColumns = ['invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
          'final_total', 'branch_name', 'reg_status', 'inv_status', 'created_by', 'print_invoice', 'print'];
    }
  }

  onChangeProg = function (search_result: object) {
    this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeDepartFlight = function (search_result: object) {
    this.model['depart_flight_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeReturnFlight = function (search_result: object) {
    this.model['return_flight_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  search() {
    if (this.model['invoice_no'] == '' && this.model['customer_name'] == '' && this.model['mobile'] == '' &&
      this.model['reg_from_date'] == undefined && this.model['reg_to_date'] == undefined &&
      this.model['dep_from_date'] == undefined && this.model['dep_to_date'] == undefined && 
      (this.model['type_id'] == 'all' || this.model['type_id'] == 'special_prog' || 
      (this.model['type_id'] == 'program' && this.model['trip_id'] == '0') || 
      ((this.model['type_id'] == 'flight' || this.model['type_id'] == 'flight_block') && 
      this.model['depart_flight_id'] == '0' && this.model['return_flight_id'] == '0'))) {

      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getContractList' };

    if (this.applicationConstants.user_info['user_id'] == undefined)
      obj['acct_number'] = this.applicationConstants.user_info['acct_number'];

    if (this.model['invoice_no'] != '') {
      obj['invoice_no'] = this.model['invoice_no'];
      // if (this.branchList.length == 2) 
      //   obj['branch_id'] = this.branchList[1]['branch_id'];
      // else {
      //   let branch_list = [];
      //   this.branchList.forEach(element => {
      //     if (element.branch_id != '0')
      //       branch_list.push({ 'branch_id': element.branch_id });
      //   });
      //   obj['branch_list'] = branch_list;
      // }
    }
    else {
      if (this.model['customer_name'] != '')
        obj['customer_name'] = this.model['customer_name'];

      if (this.model['mobile'] != '')
        obj['mobile'] = this.model['mobile'];

      obj['type_id'] = this.model['type_id'];
      if (this.model['type_id'] == 'program' && this.model['trip_id'] != '0')
        obj['trip_id'] = this.model['trip_id'];

      if (this.model['type_id'] == 'flight' && this.model['flight_id'] != '0')
        obj['flight_id'] = this.model['flight_id'];

      if (this.model['reg_from_date'] != undefined)
        obj['reg_from_date'] = this.model['reg_from_date'].getFullYear() + "-" + (this.model['reg_from_date'].getMonth() + 1) + "-" +
          this.model['reg_from_date'].getDate() + " 00:00:00";

      if (this.model['reg_to_date'] != undefined)
        obj['reg_to_date'] = this.model['reg_to_date'].getFullYear() + "-" + (this.model['reg_to_date'].getMonth() + 1) + "-" +
          this.model['reg_to_date'].getDate() + " 23:59:59";

      if (this.model['dep_from_date'] != undefined)
        obj['dep_from_date'] = this.model['dep_from_date'].getFullYear() + "-" + (this.model['dep_from_date'].getMonth() + 1) + "-" +
          this.model['dep_from_date'].getDate();

      if (this.model['dep_to_date'] != undefined)
        obj['dep_to_date'] = this.model['dep_to_date'].getFullYear() + "-" + (this.model['dep_to_date'].getMonth() + 1) + "-" +
          this.model['dep_to_date'].getDate();

      if (this.model['user_name'] != 'all')
        obj['user_name'] = this.model['user_name'];
    }

    if (this.applicationConstants.user_info['user_id'] != undefined) {
      if (this.model['branch_id'] != '0')
        obj['branch_id'] = this.model['branch_id'];
      else {
        if (this.branchList.length == 2) 
          obj['branch_id'] = this.branchList[1]['branch_id'];
        else {
          let branch_list = [];
          this.branchList.forEach(element => {
            if (element.branch_id != '0')
              branch_list.push({ 'branch_id': element.branch_id });
          });
          obj['branch_list'] = branch_list;
        }
      }
    }

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  changeProg(row) {
    this.changeDialogRef = this.dialog.open(ChangeProgComponent, {
      hasBackdrop: false,
      data: row
    });
    this.changeDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success') {

        // }
      });
  }

  print_invoice(invoice_no) {
    window.open(this.applicationConstants.generateInvoice + "?no=" + invoice_no, "_blank");
  }

  print_contract(invoice_no) {
    window.open(this.applicationConstants.contractPrint + "?invoice_no=" + invoice_no + "&lang=" + 
      this.applicationConstants.user_lang, "_blank");
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Invoice_List + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('invoice_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  returnInvoice(row) {

    let dialog_data = [{ 'invoice_no': row.invoice_no, 'invoice_date': row.full_invoice_date }];
    this.returnDateDialogRef = this.dialog.open(ReturnAllDateComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.returnDateDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.utils.returnSaleInvoice(row, result['return_date'], this);
        }
      });

    // if (confirm(this.Ret_All_Msg)) 
    //   this.utils.returnSaleInvoice(row, this);
  }

}
